const asia = {
  AF: 'Afghanistan',
  AM: 'Armenia',
  AZ: 'Azerbaijan',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BT: 'Bhutan',
  BN: 'Brunei',
  KH: 'Cambodia',
  CN: 'China',
  GE: 'Georgia',
  HK: 'Hong Kong',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran',
  IQ: 'Iraq',
  IL: 'Israel',
  JP: 'Japan',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: 'Laos',
  LB: 'Lebanon',
  MO: 'Macau',
  MY: 'Malaysia',
  MV: 'Maldives',
  MN: 'Mongolia',
  MM: 'Myanmar [Burma]',
  NP: 'Nepal',
  KP: 'North Korea',
  OM: 'Oman',
  PK: 'Pakistan',
  PH: 'Philippines',
  QA: 'Qatar',
  SA: 'Saudi Arabia',
  SG: 'Singapore',
  KR: 'South Korea',
  LK: 'Sri Lanka',
  SY: 'Syria',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TH: 'Thailand',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  AE: 'United Arab Emirates',
  UZ: 'Uzbekistan',
  VN: 'Vietnam',
  YE: 'Yemen',
};

export default asia;
